
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { Prop } from 'vue-property-decorator'
import { db } from '../../main'

@Component
export default class LockUser extends mixins(Mixin) {
  @Prop() user
  dialog_lock_user = false
  mounted(){
    console.log(this.user)
  }
  lockUser() {
    this.showNotification('loading', 'Procesando', 'Un momento por favor')
    db.collection('users')
      .doc(this.user.uid)
      .update({
        'account_info.status': 3
      })
      .then(() => {
        //Deshabilitar los usuarios del cliente
        this.showNotification('success', 'Éxito', 'Usuario bloqueado con éxito')
        this.dialog_lock_user = false
      })
      .catch(error => {
        this.showNotification(
          'fail',
          'Error',
          'Ocurrió un error al bloquear al usuario. Intenta nuevamente'
        )
        console.log(error)
        this.dialog_lock_user = false
      })
  }
}
